export default class NumberRangeOptimizerRoamingPartnersEnum {
  static ALL = 'ALL';
  static OUTBOUND = 'OUTBOUND';
  static INBOUND = 'INBOUND';
}
